import React, { useState } from 'react';
import { Download, Copy, Check, Server, Wifi, Shield, Router, Settings, Lock } from 'lucide-react';

export default function SDWANBootstrapGenerator() {
  const [deviceType, setDeviceType] = useState('vmanage');
  const [copied, setCopied] = useState(false);
  
  const [config, setConfig] = useState({
    hostname: 'vmanage',
    systemIp: '10.0.0.1',
    siteId: '1',
    organizationName: 'MyOrg',
    vbondAddress: '10.0.0.2',
    vbondPort: '12346',
    vpn0Interface: 'eth1',
    vpn0Dhcp: false,
    vpn0IpAddress: '192.168.1.10',
    vpn0Subnet: '255.255.255.0',
    vpn0Gateway: '192.168.1.1',
    tunnelInterface: true,
    tunnelColor: 'biz-internet',
    tunnelBandwidth: '100',
    natDia: false,
    vpn512Interface: 'eth0',
    vpn512Dhcp: false,
    vpn512IpAddress: '10.10.10.10',
    vpn512Subnet: '255.255.255.0',
    vpn512Gateway: '10.10.10.1',
    enableServiceVpn: false,
    serviceVpnId: '1',
    serviceVpnInterface: 'ge0/1',
    serviceVpnIp: '192.168.10.1',
    serviceVpnSubnet: '255.255.255.0',
    dns1: '8.8.8.8',
    dns2: '8.8.4.4',
    adminUsername: 'admin',
    adminPassword: 'admin',
    uuid: '',
    domainId: '1',
    vmanageCluster: false,
    clusterSize: '3',
    vsmart1Ip: '10.0.0.3',
    vsmart2Ip: '10.0.0.4',
    rootCert: false,
    enableSnmp: false,
    snmpCommunity: 'public',
    enableSyslog: false,
    syslogServer: '10.10.10.100',
    bfdMultiplier: '3',
    bfdHelloInterval: '1000',
    ipsecRekey: '86400',
    controlConnections: '2',
    portOffset: '0',
    portHopping: true,
  });

  const cidrFromSubnet = (subnet) => {
    const masks = {
      '255.255.255.255': 32, '255.255.255.254': 31, '255.255.255.252': 30,
      '255.255.255.248': 29, '255.255.255.240': 28, '255.255.255.224': 27,
      '255.255.255.192': 26, '255.255.255.128': 25, '255.255.255.0': 24,
      '255.255.254.0': 23, '255.255.252.0': 22, '255.255.248.0': 21,
      '255.255.240.0': 20, '255.255.224.0': 19, '255.255.192.0': 18,
      '255.255.128.0': 17, '255.255.0.0': 16, '255.254.0.0': 15,
      '255.252.0.0': 14, '255.248.0.0': 13, '255.240.0.0': 12,
      '255.224.0.0': 11, '255.192.0.0': 10, '255.128.0.0': 9, '255.0.0.0': 8,
    };
    return masks[subnet] || 24;
  };

  const generateVManageConfig = () => {
    const lines = [];
    lines.push('! vManage Bootstrap Configuration');
    lines.push('! SD-WAN Controller - Management and Orchestration');
    lines.push('!');
    lines.push('system');
    lines.push(` host-name ${config.hostname}`);
    lines.push(` system-ip ${config.systemIp}`);
    lines.push(` domain-id ${config.domainId}`);
    lines.push(` site-id ${config.siteId}`);
    lines.push(` organization-name ${config.organizationName}`);
    if (config.vmanageCluster) {
      lines.push(' console-baud-rate 9600');
    }
    if (config.portOffset !== '0') {
      lines.push(` port-offset ${config.portOffset}`);
    }
    lines.push(` vbond ${config.vbondAddress}`);
    lines.push('!');
    lines.push('vpn 0');
    lines.push(` dns ${config.dns1} primary`);
    if (config.dns2) {
      lines.push(` dns ${config.dns2} secondary`);
    }
    lines.push(` interface ${config.vpn0Interface}`);
    if (config.vpn0Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn0IpAddress}/${cidrFromSubnet(config.vpn0Subnet)}`);
    }
    lines.push('  ipv6 dhcp-client');
    lines.push('  tunnel-interface');
    lines.push('  allow-service all');
    lines.push('  no allow-service bgp');
    lines.push('  allow-service dhcp');
    lines.push('  allow-service dns');
    lines.push('  allow-service icmp');
    lines.push('  no allow-service sshd');
    lines.push('  allow-service netconf');
    lines.push('  no allow-service ntp');
    lines.push('  no allow-service ospf');
    lines.push('  no allow-service stun');
    lines.push('  allow-service https');
    lines.push('  !');
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn0Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn0Gateway}`);
    }
    lines.push('!');
    lines.push('vpn 512');
    lines.push(` interface ${config.vpn512Interface}`);
    if (config.vpn512Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn512IpAddress}/${cidrFromSubnet(config.vpn512Subnet)}`);
    }
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn512Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn512Gateway}`);
    }
    lines.push('!');
    lines.push('aaa');
    lines.push(` user ${config.adminUsername}`);
    lines.push(`  password ${config.adminPassword}`);
    lines.push(' !');
    lines.push('!');
    
    if (config.enableSnmp) {
      lines.push('snmp');
      lines.push(` community ${config.snmpCommunity}`);
      lines.push('  view v1default');
      lines.push('  authorization read-only');
      lines.push(' !');
      lines.push('!');
    }
    if (config.enableSyslog) {
      lines.push('logging');
      lines.push(` disk`);
      lines.push('  enable');
      lines.push(' !');
      lines.push(` server ${config.syslogServer}`);
      lines.push('  vpn 0');
      lines.push(' !');
      lines.push('!');
    }
    if (config.rootCert) {
      lines.push('');
      lines.push('! Install Root Certificate');
      lines.push('! From vManage shell:');
      lines.push('! request root-cert-chain install /home/admin/root-ca.crt');
    }
    return lines.join('\n');
  };

  const generateVBondConfig = () => {
    const lines = [];
    lines.push('! vBond Orchestrator Bootstrap Configuration');
    lines.push('! SD-WAN Controller - Orchestration and Initial Authentication');
    lines.push('!');
    lines.push('system');
    lines.push(` host-name ${config.hostname}`);
    lines.push(` system-ip ${config.systemIp}`);
    lines.push(` domain-id ${config.domainId}`);
    lines.push(` site-id ${config.siteId}`);
    lines.push(` organization-name ${config.organizationName}`);
    if (config.portOffset !== '0') {
      lines.push(` port-offset ${config.portOffset}`);
    }
    lines.push(` vbond ${config.vbondAddress} local`);
    lines.push('!');
    lines.push('vpn 0');
    lines.push(` dns ${config.dns1} primary`);
    if (config.dns2) {
      lines.push(` dns ${config.dns2} secondary`);
    }
    lines.push(` interface ${config.vpn0Interface}`);
    if (config.vpn0Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn0IpAddress}/${cidrFromSubnet(config.vpn0Subnet)}`);
    }
    lines.push('  ipv6 dhcp-client');
    lines.push('  tunnel-interface');
    lines.push('   encapsulation ipsec');
    lines.push('   allow-service all');
    lines.push('   no allow-service bgp');
    lines.push('   allow-service dhcp');
    lines.push('   allow-service dns');
    lines.push('   allow-service icmp');
    lines.push('   no allow-service sshd');
    lines.push('   allow-service netconf');
    lines.push('   no allow-service ntp');
    lines.push('   no allow-service ospf');
    lines.push('   no allow-service stun');
    lines.push('   no allow-service https');
    lines.push('  !');
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn0Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn0Gateway}`);
    }
    lines.push('!');
    lines.push('vpn 512');
    lines.push(` interface ${config.vpn512Interface}`);
    if (config.vpn512Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn512IpAddress}/${cidrFromSubnet(config.vpn512Subnet)}`);
    }
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn512Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn512Gateway}`);
    }
    lines.push('!');
    lines.push('aaa');
    lines.push(` user ${config.adminUsername}`);
    lines.push(`  password ${config.adminPassword}`);
    lines.push(' !');
    lines.push('!');
    if (config.enableSyslog) {
      lines.push('logging');
      lines.push(` disk`);
      lines.push('  enable');
      lines.push(' !');
      lines.push(` server ${config.syslogServer}`);
      lines.push('  vpn 0');
      lines.push(' !');
      lines.push('!');
    }
    return lines.join('\n');
  };

  const generateVSmartConfig = () => {
    const lines = [];
    lines.push('! vSmart Controller Bootstrap Configuration');
    lines.push('! SD-WAN Controller - Policy and Routing Intelligence');
    lines.push('!');
    lines.push('system');
    lines.push(` host-name ${config.hostname}`);
    lines.push(` system-ip ${config.systemIp}`);
    lines.push(` domain-id ${config.domainId}`);
    lines.push(` site-id ${config.siteId}`);
    lines.push(` organization-name ${config.organizationName}`);
    if (config.portOffset !== '0') {
      lines.push(` port-offset ${config.portOffset}`);
    }
    lines.push(` vbond ${config.vbondAddress}`);
    lines.push('!');
    lines.push('vpn 0');
    lines.push(` dns ${config.dns1}`);
    if (config.dns2) {
      lines.push(` dns ${config.dns2}`);
    }
    lines.push(` interface ${config.vpn0Interface}`);
    if (config.vpn0Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn0IpAddress}/${cidrFromSubnet(config.vpn0Subnet)}`);
    }
    lines.push('  ipv6 dhcp-client');
    lines.push('  tunnel-interface');
    lines.push('   encapsulation ipsec');
    lines.push('   allow-service all');
    lines.push('   no allow-service bgp');
    lines.push('   allow-service dhcp');
    lines.push('   allow-service dns');
    lines.push('   allow-service icmp');
    lines.push('   no allow-service sshd');
    lines.push('   allow-service netconf');
    lines.push('   no allow-service ntp');
    lines.push('   no allow-service ospf');
    lines.push('   no allow-service stun');
    lines.push('   no allow-service https');
    lines.push('  !');
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn0Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn0Gateway}`);
    }
    lines.push('!');
    lines.push('vpn 512');
    lines.push(` interface ${config.vpn512Interface}`);
    if (config.vpn512Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn512IpAddress}/${cidrFromSubnet(config.vpn512Subnet)}`);
    }
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn512Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn512Gateway}`);
    }
    lines.push('!');
    lines.push('aaa');
    lines.push(` user ${config.adminUsername}`);
    lines.push(`  password ${config.adminPassword}`);
    lines.push(' !');
    lines.push('!');
    if (config.enableSyslog) {
      lines.push('logging');
      lines.push(` disk`);
      lines.push('  enable');
      lines.push(' !');
      lines.push(` server ${config.syslogServer}`);
      lines.push('  vpn 0');
      lines.push(' !');
      lines.push('!');
    }
    return lines.join('\n');
  };

  const generateVEdgeConfig = () => {
    const lines = [];
    lines.push('! vEdge Router Bootstrap Configuration');
    lines.push('! SD-WAN Edge Device - Viptela OS');
    lines.push('!');
    lines.push('system');
    lines.push(` host-name ${config.hostname}`);
    lines.push(` system-ip ${config.systemIp}`);
    lines.push(` domain-id ${config.domainId}`);
    lines.push(` site-id ${config.siteId}`);
    lines.push(` organization-name ${config.organizationName}`);
    if (config.uuid) {
      lines.push(` uuid ${config.uuid}`);
    }
    if (config.portOffset !== '0') {
      lines.push(` port-offset ${config.portOffset}`);
    }
    lines.push(` vbond ${config.vbondAddress} port ${config.vbondPort}`);
    lines.push(` control-session-pps 300`);
    lines.push(' admin-tech-on-failure');
    lines.push(' no route-consistency-check');
    lines.push(' no vrrp-advt-with-phymac');
    lines.push(' arp-proxy');
    if (config.portHopping) {
      lines.push(' port-hop');
    }
    lines.push(' device-groups');
    lines.push(' controller-group');
    lines.push(' !');
    lines.push('!');
    lines.push('vpn 0');
    lines.push(` name "Transport VPN"`);
    lines.push(` dns ${config.dns1} primary`);
    if (config.dns2) {
      lines.push(` dns ${config.dns2} secondary`);
    }
    lines.push(` interface ${config.vpn0Interface}`);
    if (config.vpn0Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn0IpAddress}/${cidrFromSubnet(config.vpn0Subnet)}`);
    }
    lines.push('  ipv6 dhcp-client');
    if (config.tunnelInterface) {
      lines.push('  tunnel-interface');
      lines.push(`   encapsulation ipsec`);
      lines.push(`   color ${config.tunnelColor}`);
      if (config.controlConnections) {
        lines.push(`   max-control-connections ${config.controlConnections}`);
      }
      lines.push(`   vmanage-connection-preference 5`);
      if (config.natDia) {
        lines.push('   allow-service all');
      } else {
        lines.push('   allow-service all');
        lines.push('   no allow-service bgp');
        lines.push('   allow-service dhcp');
        lines.push('   allow-service dns');
        lines.push('   allow-service icmp');
        lines.push('   no allow-service sshd');
        lines.push('   allow-service netconf');
        lines.push('   no allow-service ntp');
        lines.push('   no allow-service ospf');
        lines.push('   no allow-service stun');
        lines.push('   no allow-service snmp');
        lines.push('   no allow-service https');
      }
      lines.push('  !');
    }
    if (config.natDia) {
      lines.push('  nat');
    }
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn0Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn0Gateway}`);
    }
    lines.push('!');
    
    if (config.enableServiceVpn) {
      lines.push(`vpn ${config.serviceVpnId}`);
      lines.push(` name "Service VPN"`);
      lines.push(` interface ${config.serviceVpnInterface}`);
      lines.push(`  ip address ${config.serviceVpnIp}/${cidrFromSubnet(config.serviceVpnSubnet)}`);
      lines.push('  no shutdown');
      lines.push(' !');
      lines.push('!');
    }
    
    lines.push('vpn 512');
    lines.push(` name "Management VPN"`);
    lines.push(` interface ${config.vpn512Interface}`);
    if (config.vpn512Dhcp) {
      lines.push('  ip dhcp-client');
    } else {
      lines.push(`  ip address ${config.vpn512IpAddress}/${cidrFromSubnet(config.vpn512Subnet)}`);
    }
    lines.push('  no shutdown');
    lines.push(' !');
    if (!config.vpn512Dhcp) {
      lines.push(` ip route 0.0.0.0/0 ${config.vpn512Gateway}`);
    }
    lines.push('!');
    lines.push('aaa');
    lines.push(' auth-order local radius tacacs');
    lines.push(' usergroup basic');
    lines.push('  task system read write');
    lines.push('  task interface read write');
    lines.push(' !');
    lines.push(' usergroup netadmin');
    lines.push(' !');
    lines.push(' usergroup operator');
    lines.push('  task system read');
    lines.push('  task interface read');
    lines.push('  task policy read');
    lines.push('  task routing read');
    lines.push('  task security read');
    lines.push(' !');
    lines.push(` user ${config.adminUsername}`);
    lines.push(`  password ${config.adminPassword}`);
    lines.push(' !');
    lines.push('!');
    lines.push('security');
    lines.push(' ipsec');
    lines.push('  authentication-type ah-sha1-hmac sha1-hmac');
    lines.push('  integrity-type ip-udp-esp ip-udp-esp-no-id');
    lines.push(`  rekey ${config.ipsecRekey}`);
    lines.push('  replay-window 512');
    lines.push(' !');
    lines.push('!');
    
    lines.push('bfd app-route multiplier ' + config.bfdMultiplier);
    lines.push('bfd app-route poll-interval ' + config.bfdHelloInterval);
    lines.push('!');
    
    if (config.enableSnmp) {
      lines.push('snmp');
      lines.push(' vpn 512');
      lines.push(` community ${config.snmpCommunity}`);
      lines.push('  view v1default');
      lines.push('  authorization read-only');
      lines.push(' !');
      lines.push('!');
    }
    if (config.enableSyslog) {
      lines.push('logging');
      lines.push(` disk`);
      lines.push('  enable');
      lines.push('  file rotate 10');
      lines.push('  file size 10');
      lines.push(' !');
      lines.push(` server ${config.syslogServer}`);
      lines.push('  vpn 512');
      lines.push('  priority information');
      lines.push(' !');
      lines.push('!');
    }
    lines.push('omp');
    lines.push(' no shutdown');
    lines.push(' graceful-restart');
    lines.push(' no as-dot-notation');
    lines.push(' timers');
    lines.push('  holdtime 60');
    lines.push('  advertisement-interval 1');
    lines.push('  graceful-restart-timer 43200');
    lines.push('  eor-timer 300');
    lines.push(' !');
    lines.push('!');
    return lines.join('\n');
  };

  const generateCEdgeConfig = () => {
    const lines = [];
    lines.push('! cEdge Router Bootstrap Configuration');
    lines.push('! SD-WAN Edge Device - IOS-XE SD-WAN');
    lines.push('!');
    lines.push(`hostname ${config.hostname}`);
    lines.push('!');
    lines.push('system');
    lines.push(` system-ip ${config.systemIp}`);
    lines.push(` site-id ${config.siteId}`);
    lines.push(` organization-name ${config.organizationName}`);
    if (config.portOffset !== '0') {
      lines.push(` port-offset ${config.portOffset}`);
    }
    if (config.portHopping) {
      lines.push(' port-hop');
    }
    lines.push(` vbond ${config.vbondAddress} port ${config.vbondPort}`);
    lines.push('!');
    lines.push('vtp mode transparent');
    lines.push('!');
    lines.push('ip host vbond.cisco.com ' + config.vbondAddress);
    lines.push('!');
    lines.push('ip name-server ' + config.dns1);
    lines.push('ip name-server ' + config.dns2);
    lines.push('!');
    lines.push('sdwan');
    lines.push(' interface ' + config.vpn0Interface);
    if (config.tunnelInterface) {
      lines.push('  tunnel-interface');
      lines.push(`   encapsulation ipsec`);
      lines.push(`   color ${config.tunnelColor}`);
      if (config.controlConnections) {
        lines.push(`   max-control-connections ${config.controlConnections}`);
      }
      if (config.natDia) {
        lines.push('   allow-service all');
      } else {
        lines.push('   allow-service all');
        lines.push('   no allow-service bgp');
        lines.push('   allow-service dhcp');
        lines.push('   allow-service dns');
        lines.push('   allow-service icmp');
        lines.push('   no allow-service sshd');
        lines.push('   allow-service netconf');
        lines.push('   no allow-service ntp');
        lines.push('   no allow-service ospf');
        lines.push('   no allow-service stun');
        lines.push('   no allow-service snmp');
        lines.push('   no allow-service https');
      }
      lines.push('  exit');
    }
    lines.push(' exit');
    lines.push('!');
    
    lines.push('interface ' + config.vpn0Interface);
    lines.push(' description WAN Transport');
    lines.push(' no shutdown');
    if (config.vpn0Dhcp) {
      lines.push(' ip address dhcp');
    } else {
      lines.push(' ip address ' + config.vpn0IpAddress + ' ' + config.vpn0Subnet);
    }
    if (config.natDia) {
      lines.push(' ip nat outside');
    }
    lines.push(' negotiation auto');
    lines.push('!');
    
    if (config.enableServiceVpn) {
      lines.push('interface ' + config.serviceVpnInterface);
      lines.push(' description Service VPN');
      lines.push(' no shutdown');
      lines.push(' vrf forwarding ' + config.serviceVpnId);
      lines.push(' ip address ' + config.serviceVpnIp + ' ' + config.serviceVpnSubnet);
      if (config.natDia) {
        lines.push(' ip nat inside');
      }
      lines.push(' negotiation auto');
      lines.push('!');
    }
    
    lines.push('interface ' + config.vpn512Interface);
    lines.push(' description Management');
    lines.push(' no shutdown');
    lines.push(' vrf forwarding 512');
    if (config.vpn512Dhcp) {
      lines.push(' ip address dhcp');
    } else {
      lines.push(' ip address ' + config.vpn512IpAddress + ' ' + config.vpn512Subnet);
    }
    lines.push(' negotiation auto');
    lines.push('!');
    
    if (!config.vpn0Dhcp) {
      lines.push('ip route 0.0.0.0 0.0.0.0 ' + config.vpn0Gateway);
    }
    if (!config.vpn512Dhcp) {
      lines.push('ip route vrf 512 0.0.0.0 0.0.0.0 ' + config.vpn512Gateway);
    }
    if (config.natDia && config.enableServiceVpn) {
      lines.push('ip nat inside source list NAT_ACL interface ' + config.vpn0Interface + ' overload');
      lines.push('!');
      lines.push('ip access-list standard NAT_ACL');
      lines.push(' permit any');
    }
    lines.push('!');
    lines.push('aaa new-model');
    lines.push('!');
    lines.push('aaa authentication login default local');
    lines.push('aaa authorization exec default local');
    lines.push('!');
    lines.push('aaa session-id common');
    lines.push('!');
    lines.push(`username ${config.adminUsername} privilege 15 secret ${config.adminPassword}`);
    lines.push('!');
    lines.push('crypto ikev2 proposal AES256/GCM/256');
    lines.push(' encryption aes-gcm-256');
    lines.push(' prf sha512');
    lines.push(' group 20 21');
    lines.push('!');
    lines.push('crypto ikev2 policy AES256/GCM/256');
    lines.push(' proposal AES256/GCM/256');
    lines.push('!');
    
    lines.push('bfd slow-timers ' + config.bfdHelloInterval);
    lines.push('!');
    
    if (config.enableSnmp) {
      lines.push('snmp-server community ' + config.snmpCommunity + ' RO');
      lines.push('!');
    }
    if (config.enableSyslog) {
      lines.push('logging host ' + config.syslogServer + ' vrf 512');
      lines.push('logging trap informational');
      lines.push('!');
    }
    lines.push('line con 0');
    lines.push(' stopbits 1');
    lines.push('!');
    lines.push('line vty 0 4');
    lines.push(' transport input ssh');
    lines.push('!');
    lines.push('line vty 5 80');
    lines.push(' transport input ssh');
    lines.push('!');
    return lines.join('\n');
  };

  const generateConfig = () => {
    switch(deviceType) {
      case 'vmanage': return generateVManageConfig();
      case 'vbond': return generateVBondConfig();
      case 'vsmart': return generateVSmartConfig();
      case 'vedge': return generateVEdgeConfig();
      case 'cedge': return generateCEdgeConfig();
      default: return '';
    }
  };

  const generatedConfig = generateConfig();

  const handleCopy = async () => {
    await navigator.clipboard.writeText(generatedConfig);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleDownload = () => {
    const blob = new Blob([generatedConfig], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${config.hostname}-bootstrap.cfg`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const updateConfig = (field, value) => {
    setConfig(prev => ({ ...prev, [field]: value }));
  };

  const deviceTypes = [
    { id: 'vmanage', name: 'vManage', icon: Server, desc: 'Orchestration' },
    { id: 'vbond', name: 'vBond', icon: Wifi, desc: 'Authenticator' },
    { id: 'vsmart', name: 'vSmart', icon: Shield, desc: 'Controller' },
    { id: 'vedge', name: 'vEdge', icon: Router, desc: 'Viptela OS' },
    { id: 'cedge', name: 'cEdge', icon: Router, desc: 'IOS-XE' },
  ];

  const colors = [
    'default', 'mpls', 'metro-ethernet', 'biz-internet', 'public-internet',
    'lte', '3g', 'red', 'green', 'blue', 'gold', 'silver', 'bronze',
    'custom1', 'custom2', 'custom3', 'private1', 'private2', 'private3',
  ];

  return (
    <div className="min-h-screen bg-gray-950 p-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-100 mb-2 tracking-tight">
            Cisco SD-WAN Bootstrap Generator
          </h1>
          <p className="text-gray-500 text-lg"> for Cisco SD-WAN 20.X</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-6">
          {deviceTypes.map(device => {
            const Icon = device.icon;
            const isActive = deviceType === device.id;
            return (
              <button
                key={device.id}
                onClick={() => setDeviceType(device.id)}
                className={`relative p-5 rounded-lg border-2 transition-all duration-200 ${
                  isActive
                    ? 'bg-gray-900 border-cyan-600 shadow-lg shadow-cyan-900/20'
                    : 'bg-gray-900/90 border-gray-800 hover:bg-gray-800/90 hover:border-gray-700'
                }`}
              >
                {isActive && (
                  <div className="absolute top-2 right-2">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"></div>
                  </div>
                )}
                <Icon className={`w-10 h-10 mx-auto mb-2 ${isActive ? 'text-cyan-400' : 'text-gray-500'}`} />
                <div className={`font-bold text-lg ${isActive ? 'text-cyan-400' : 'text-gray-400'}`}>
                  {device.name}
                </div>
                <div className="text-xs text-gray-600 mt-1">{device.desc}</div>
              </button>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-gray-900/90 backdrop-blur-sm rounded-xl p-6 border border-gray-800 shadow-xl overflow-y-auto" style={{maxHeight: '80vh'}}>
            <div className="flex items-center gap-2 mb-6">
              <Settings className="w-6 h-6 text-cyan-500" />
              <h2 className="text-2xl font-bold text-gray-200">Configuration Parameters</h2>
            </div>
            
            <div className="space-y-6">
              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4 flex items-center gap-2">
                  <Server className="w-5 h-5" />
                  System Configuration
                </h3>
                
                <div className="space-y-3">
                  <div>
                    <label className="block text-gray-300 text-sm mb-1.5 font-medium">Hostname</label>
                    <input
                      type="text"
                      value={config.hostname}
                      onChange={(e) => updateConfig('hostname', e.target.value)}
                      className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-transparent transition"
                      placeholder="e.g., vmanage-dc1"
                    />
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">System IP</label>
                      <input
                        type="text"
                        value={config.systemIp}
                        onChange={(e) => updateConfig('systemIp', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="10.0.0.1"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Site ID</label>
                      <input
                        type="text"
                        value={config.siteId}
                        onChange={(e) => updateConfig('siteId', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="1"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Organization</label>
                      <input
                        type="text"
                        value={config.organizationName}
                        onChange={(e) => updateConfig('organizationName', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="MyOrg"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Domain ID</label>
                      <input
                        type="text"
                        value={config.domainId}
                        onChange={(e) => updateConfig('domainId', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="1"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-3">
                    <div className="col-span-2">
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">vBond Address</label>
                      <input
                        type="text"
                        value={config.vbondAddress}
                        onChange={(e) => updateConfig('vbondAddress', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="10.0.0.2"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Port</label>
                      <input
                        type="text"
                        value={config.vbondPort}
                        onChange={(e) => updateConfig('vbondPort', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="12346"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Port Offset</label>
                      <input
                        type="text"
                        value={config.portOffset}
                        onChange={(e) => updateConfig('portOffset', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="0"
                      />
                    </div>
                    {(deviceType === 'vedge' || deviceType === 'cedge') && (
                      <div>
                        <label className="block text-gray-300 text-sm mb-1.5 font-medium">Control Connections</label>
                        <input
                          type="text"
                          value={config.controlConnections}
                          onChange={(e) => updateConfig('controlConnections', e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                          placeholder="2"
                        />
                      </div>
                    )}
                  </div>

                  {(deviceType === 'vedge' || deviceType === 'cedge') && (
                    <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                      <input
                        type="checkbox"
                        id="portHopping"
                        checked={config.portHopping}
                        onChange={(e) => updateConfig('portHopping', e.target.checked)}
                        className="w-4 h-4 accent-cyan-600"
                      />
                      <label htmlFor="portHopping" className="text-gray-300 text-sm font-medium">Enable Port Hopping</label>
                    </div>
                  )}

                  {deviceType === 'vedge' && (
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">UUID (Optional)</label>
                      <input
                        type="text"
                        value={config.uuid}
                        onChange={(e) => updateConfig('uuid', e.target.value)}
                        placeholder="Leave empty for auto-generation"
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4 flex items-center gap-2">
                  <Wifi className="w-5 h-5" />
                  VPN 0 - Transport
                </h3>
                
                <div className="space-y-3">
                  <div>
                    <label className="block text-gray-300 text-sm mb-1.5 font-medium">Interface</label>
                    <input
                      type="text"
                      value={config.vpn0Interface}
                      onChange={(e) => updateConfig('vpn0Interface', e.target.value)}
                      className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-transparent transition"
                      placeholder="eth1 or GigabitEthernet0/0/0"
                    />
                  </div>

                  <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                    <input
                      type="checkbox"
                      id="vpn0dhcp"
                      checked={config.vpn0Dhcp}
                      onChange={(e) => updateConfig('vpn0Dhcp', e.target.checked)}
                      className="w-4 h-4 accent-cyan-600"
                    />
                    <label htmlFor="vpn0dhcp" className="text-gray-300 text-sm font-medium">Get IP from DHCP</label>
                  </div>

                  {!config.vpn0Dhcp && (
                    <>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-gray-300 text-sm mb-1.5 font-medium">IP Address</label>
                          <input
                            type="text"
                            value={config.vpn0IpAddress}
                            onChange={(e) => updateConfig('vpn0IpAddress', e.target.value)}
                            className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                            placeholder="192.168.1.10"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-300 text-sm mb-1.5 font-medium">Subnet Mask</label>
                          <input
                            type="text"
                            value={config.vpn0Subnet}
                            onChange={(e) => updateConfig('vpn0Subnet', e.target.value)}
                            className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                            placeholder="255.255.255.0"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-gray-300 text-sm mb-1.5 font-medium">Gateway</label>
                        <input
                          type="text"
                          value={config.vpn0Gateway}
                          onChange={(e) => updateConfig('vpn0Gateway', e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                          placeholder="192.168.1.1"
                        />
                      </div>
                    </>
                  )}

                  {(deviceType === 'vedge' || deviceType === 'cedge') && (
                    <>
                      <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                        <input
                          type="checkbox"
                          id="tunnel"
                          checked={config.tunnelInterface}
                          onChange={(e) => updateConfig('tunnelInterface', e.target.checked)}
                          className="w-4 h-4 accent-cyan-600"
                        />
                        <label htmlFor="tunnel" className="text-gray-300 text-sm font-medium">Enable Tunnel Interface</label>
                      </div>

                      {config.tunnelInterface && (
                        <>
                          <div>
                            <label className="block text-gray-300 text-sm mb-1.5 font-medium">Tunnel Color</label>
                            <select
                              value={config.tunnelColor}
                              onChange={(e) => updateConfig('tunnelColor', e.target.value)}
                              className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                            >
                              {colors.map(c => (
                                <option key={c} value={c} className="bg-gray-900">{c}</option>
                              ))}
                            </select>
                          </div>
                          
                          <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                            <input
                              type="checkbox"
                              id="natdia"
                              checked={config.natDia}
                              onChange={(e) => updateConfig('natDia', e.target.checked)}
                              className="w-4 h-4 accent-cyan-600"
                            />
                            <label htmlFor="natdia" className="text-gray-300 text-sm font-medium">Enable NAT DIA (Direct Internet Access)</label>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4 flex items-center gap-2">
                  <Lock className="w-5 h-5" />
                  VPN 512 - Management
                </h3>
                
                <div className="space-y-3">
                  <div>
                    <label className="block text-gray-300 text-sm mb-1.5 font-medium">Interface</label>
                    <input
                      type="text"
                      value={config.vpn512Interface}
                      onChange={(e) => updateConfig('vpn512Interface', e.target.value)}
                      className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                      placeholder="eth0 or GigabitEthernet0"
                    />
                  </div>

                  <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                    <input
                      type="checkbox"
                      id="vpn512dhcp"
                      checked={config.vpn512Dhcp}
                      onChange={(e) => updateConfig('vpn512Dhcp', e.target.checked)}
                      className="w-4 h-4 accent-cyan-600"
                    />
                    <label htmlFor="vpn512dhcp" className="text-gray-300 text-sm font-medium">Get IP from DHCP</label>
                  </div>

                  {!config.vpn512Dhcp && (
                    <>
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="block text-gray-300 text-sm mb-1.5 font-medium">IP Address</label>
                          <input
                            type="text"
                            value={config.vpn512IpAddress}
                            onChange={(e) => updateConfig('vpn512IpAddress', e.target.value)}
                            className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                            placeholder="10.10.10.10"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-300 text-sm mb-1.5 font-medium">Subnet Mask</label>
                          <input
                            type="text"
                            value={config.vpn512Subnet}
                            onChange={(e) => updateConfig('vpn512Subnet', e.target.value)}
                            className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                            placeholder="255.255.255.0"
                          />
                        </div>
                      </div>

                      <div>
                        <label className="block text-gray-300 text-sm mb-1.5 font-medium">Gateway</label>
                        <input
                          type="text"
                          value={config.vpn512Gateway}
                          onChange={(e) => updateConfig('vpn512Gateway', e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                          placeholder="10.10.10.1"
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>

              {(deviceType === 'vedge' || deviceType === 'cedge') && (
                <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                  <h3 className="text-lg font-semibold text-cyan-500 mb-4">Service VPN (LAN)</h3>
                  
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                      <input
                        type="checkbox"
                        id="serviceVpn"
                        checked={config.enableServiceVpn}
                        onChange={(e) => updateConfig('enableServiceVpn', e.target.checked)}
                        className="w-4 h-4 accent-cyan-600"
                      />
                      <label htmlFor="serviceVpn" className="text-gray-300 text-sm font-medium">Enable Service VPN</label>
                    </div>

                    {config.enableServiceVpn && (
                      <>
                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="block text-gray-300 text-sm mb-1.5 font-medium">VPN ID</label>
                            <input
                              type="text"
                              value={config.serviceVpnId}
                              onChange={(e) => updateConfig('serviceVpnId', e.target.value)}
                              className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                              placeholder="1"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-300 text-sm mb-1.5 font-medium">Interface</label>
                            <input
                              type="text"
                              value={config.serviceVpnInterface}
                              onChange={(e) => updateConfig('serviceVpnInterface', e.target.value)}
                              className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                              placeholder="ge0/1"
                            />
                          </div>
                        </div>

                        <div className="grid grid-cols-2 gap-3">
                          <div>
                            <label className="block text-gray-300 text-sm mb-1.5 font-medium">IP Address</label>
                            <input
                              type="text"
                              value={config.serviceVpnIp}
                              onChange={(e) => updateConfig('serviceVpnIp', e.target.value)}
                              className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                              placeholder="192.168.10.1"
                            />
                          </div>
                          <div>
                            <label className="block text-gray-300 text-sm mb-1.5 font-medium">Subnet Mask</label>
                            <input
                              type="text"
                              value={config.serviceVpnSubnet}
                              onChange={(e) => updateConfig('serviceVpnSubnet', e.target.value)}
                              className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                              placeholder="255.255.255.0"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4">DNS Servers</h3>
                
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Primary DNS</label>
                      <input
                        type="text"
                        value={config.dns1}
                        onChange={(e) => updateConfig('dns1', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="8.8.8.8"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Secondary DNS</label>
                      <input
                        type="text"
                        value={config.dns2}
                        onChange={(e) => updateConfig('dns2', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="8.8.4.4"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4">AAA Configuration</h3>
                
                <div className="space-y-3">
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Admin Username</label>
                      <input
                        type="text"
                        value={config.adminUsername}
                        onChange={(e) => updateConfig('adminUsername', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="admin"
                      />
                    </div>
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Admin Password</label>
                      <input
                        type="password"
                        value={config.adminPassword}
                        onChange={(e) => updateConfig('adminPassword', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="••••••••"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                <h3 className="text-lg font-semibold text-cyan-500 mb-4">Monitoring & Logging</h3>
                
                <div className="space-y-3">
                  <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                    <input
                      type="checkbox"
                      id="snmp"
                      checked={config.enableSnmp}
                      onChange={(e) => updateConfig('enableSnmp', e.target.checked)}
                      className="w-4 h-4 accent-cyan-600"
                    />
                    <label htmlFor="snmp" className="text-gray-300 text-sm font-medium">Enable SNMP</label>
                  </div>

                  {config.enableSnmp && (
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">SNMP Community String</label>
                      <input
                        type="text"
                        value={config.snmpCommunity}
                        onChange={(e) => updateConfig('snmpCommunity', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="public"
                      />
                    </div>
                  )}

                  <div className="flex items-center gap-3 p-3 bg-gray-950/80 rounded-lg">
                    <input
                      type="checkbox"
                      id="syslog"
                      checked={config.enableSyslog}
                      onChange={(e) => updateConfig('enableSyslog', e.target.checked)}
                      className="w-4 h-4 accent-cyan-600"
                    />
                    <label htmlFor="syslog" className="text-gray-300 text-sm font-medium">Enable Syslog</label>
                  </div>

                  {config.enableSyslog && (
                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">Syslog Server</label>
                      <input
                        type="text"
                        value={config.syslogServer}
                        onChange={(e) => updateConfig('syslogServer', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="10.10.10.100"
                      />
                    </div>
                  )}
                </div>
              </div>

              {(deviceType === 'vedge' || deviceType === 'cedge') && (
                <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
                  <h3 className="text-lg font-semibold text-cyan-500 mb-4">Advanced Settings</h3>
                  
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="block text-gray-300 text-sm mb-1.5 font-medium">BFD Multiplier</label>
                        <input
                          type="text"
                          value={config.bfdMultiplier}
                          onChange={(e) => updateConfig('bfdMultiplier', e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                          placeholder="3"
                        />
                      </div>
                      <div>
                        <label className="block text-gray-300 text-sm mb-1.5 font-medium">BFD Hello (ms)</label>
                        <input
                          type="text"
                          value={config.bfdHelloInterval}
                          onChange={(e) => updateConfig('bfdHelloInterval', e.target.value)}
                          className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                          placeholder="1000"
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-gray-300 text-sm mb-1.5 font-medium">IPsec Rekey Timer (seconds)</label>
                      <input
                        type="text"
                        value={config.ipsecRekey}
                        onChange={(e) => updateConfig('ipsecRekey', e.target.value)}
                        className="w-full px-4 py-2.5 bg-gray-950 border border-gray-700 rounded-lg text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-600 transition"
                        placeholder="86400"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="bg-gray-900/90 backdrop-blur-sm rounded-xl p-6 border border-gray-800 shadow-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-gray-200">Generated Configuration</h2>
              <div className="flex gap-2">
                <button
                  onClick={handleCopy}
                  className="flex items-center gap-2 px-4 py-2.5 bg-cyan-700 hover:bg-cyan-600 text-white rounded-lg transition-all duration-200 font-medium"
                >
                  {copied ? <Check size={18} /> : <Copy size={18} />}
                  {copied ? 'Copied!' : 'Copy'}
                </button>
                <button
                  onClick={handleDownload}
                  className="flex items-center gap-2 px-4 py-2.5 bg-emerald-700 hover:bg-emerald-600 text-white rounded-lg transition-all duration-200 font-medium"
                >
                  <Download size={18} />
                  Download
                </button>
              </div>
            </div>

            <div className="bg-black rounded-lg p-5 overflow-auto border border-gray-800" style={{ maxHeight: '65vh' }}>
              <pre className="text-emerald-400 text-sm font-mono whitespace-pre leading-relaxed">
                {generatedConfig}
              </pre>
            </div>

            <div className="mt-4 p-4 bg-yellow-900/20 border-l-4 border-yellow-600 rounded-lg">
              <p className="text-yellow-200 text-sm leading-relaxed">
                <strong className="text-yellow-300">⚠️ Bootstrap Configuration</strong><br/>
                {deviceType === 'vmanage' && 'After initial setup, complete vManage wizard and add controllers/devices.'}
                {deviceType === 'vbond' && 'Ensure vBond is reachable from all sites and controllers via public IP or NAT.'}
                {deviceType === 'vsmart' && 'After bootstrap, vSmart will automatically sync with vManage.'}
                {(deviceType === 'vedge' || deviceType === 'cedge') && 'Configure additional features through vManage templates. NAT DIA and Service VPN included if enabled.'}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-gray-900/90 backdrop-blur-sm rounded-xl p-6 border border-gray-800 shadow-xl">
          <h3 className="text-2xl font-bold text-gray-200 mb-4">Bootstrap Instructions</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-300 text-sm">
            
            <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
              <h4 className="font-bold text-cyan-500 mb-3 text-lg">Controllers (vManage/vBond/vSmart)</h4>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>Access device via console connection</li>
                <li>Login with default credentials</li>
                <li>Enter configuration mode: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">config</code></li>
                <li>Paste generated configuration</li>
                <li>Commit changes: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">commit and-quit</code></li>
                <li>Verify connectivity to other controllers</li>
              </ol>
            </div>

            <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
              <h4 className="font-bold text-cyan-500 mb-3 text-lg">vEdge Devices</h4>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>Console into device</li>
                <li>Enter config mode: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">config</code></li>
                <li>Paste configuration</li>
                <li>Commit: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">commit and-quit</code></li>
                <li>Verify: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">show control connections</code></li>
              </ol>
            </div>

            <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
              <h4 className="font-bold text-cyan-500 mb-3 text-lg">cEdge Devices</h4>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>Enter privileged EXEC mode</li>
                <li>Config mode: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">configure terminal</code></li>
                <li>Paste configuration</li>
                <li>Save: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">write memory</code></li>
                <li>Check: <code className="bg-gray-950 px-2 py-1 rounded text-cyan-400">show sdwan control connections</code></li>
              </ol>
            </div>

            <div className="bg-gray-800/80 rounded-lg p-4 border border-gray-700">
              <h4 className="font-bold text-cyan-500 mb-3 text-lg">Post-Bootstrap Steps</h4>
              <ol className="list-decimal list-inside space-y-2 ml-2">
                <li>Install certificates on all devices</li>
                <li>Verify control plane connections</li>
                <li>Configure templates in vManage</li>
                <li>Push device templates to edges</li>
                <li>Verify BFD sessions and OMP routes</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center text-gray-600 text-sm pb-4">
          <p>Cisco SD-WAN Bootstrap Generator | Vaibhav Chamoli</p>
        </div>
      </div>
    </div>
  );
}
